import {
  isActionRequired,
  isActiveStatus,
  isTerminalStatus,
} from '@/utils/trade-blotter/compute-order-status'

import { AdvisorViewStatus } from './advisor-view-status'

export enum OrderStatusGroup {
  All = 'All',
  ActionRequired = 'Action Required',
  Active = 'Active',
  Completed = 'Completed',
}

export const OrderStatusGroupMapping: Record<
  OrderStatusGroup,
  AdvisorViewStatus[]
> = {
  [OrderStatusGroup.All]: Object.values(AdvisorViewStatus),
  [OrderStatusGroup.Active]: Object.values(AdvisorViewStatus).filter((status) =>
    isActiveStatus(status),
  ),
  // Action Required is a subset of Active statuses
  // In trade blotter, Action Required is displayed in a separate group above the rest of the Active statuses
  [OrderStatusGroup.ActionRequired]: Object.values(AdvisorViewStatus).filter(
    (status) => isActionRequired(status),
  ),
  [OrderStatusGroup.Completed]: Object.values(AdvisorViewStatus).filter(
    (status) => isTerminalStatus(status),
  ),
}

export enum TradeBlotterColumnId {
  ACCOUNT = 'account',
  ACCRUED_INTEREST = 'accrued_interest',
  ALLOCATION_STATUS = 'allocation_status',
  AMOUNT = 'amount',
  ANNOTATION = 'annotation',
  ASSET_TYPE = 'asset_type',
  BOND_TYPE = 'bond_type',
  CANCEL_REASON = 'cancel_reason',
  CLIENT_ORDER_ID = 'client_order_id',
  COUNTERPARTY = 'counterparty',
  CUSIP = 'cusip',
  CUSTODIAN = 'custodian',
  DESCRIPTION = 'description',
  DESCRIPTION_SHORT = 'description_short',
  EXECUTION = 'execution',
  EXTENDED_HOURS = 'extended_hours',
  FILLED = 'filled',
  FILLED_AVG_PRICE = 'filled_avg_price',
  HAS_DISCRETIONARY_AUTHORITY = 'has_discretionary_authority',
  IB_NAME = 'ib_name',
  ICON_ANNOTATION = 'icon_annotation',
  ID = 'id',
  IDENTIFIER = 'identifier',
  ISIN = 'isin',
  LIMIT_PRICE = 'limit_price',
  LIST_RFQ_NAME = 'list_rfq_name',
  NET_MONEY = 'net_money',
  ORDER_PROGRESS = 'order_progress',
  PRIME_BROKERAGE_ENABLED = 'prime_brokerage_enabled',
  QUANTITY = 'quantity',
  REJECT_REASON = 'reject_reason',
  SIDE = 'side',
  STATUS = 'advisorViewStatus',
  SUBMISSION_NAME = 'submission_name',
  TIME = 'time',
  TIME_LEFT = 'time_left',
  TYPE = 'type',
  SETTLEMENT_DATE = 'settlement_date',
  VENUE = 'venue',
  YTW = 'ytw',
}
